module.exports = __webpack_public_path__ + "static/img/top-img4.30d0314.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/top-img4.png
// module id = Zj+y
// module chunks = 0